"use client";

import {createContext, useContext} from "react";
import useHoverMenus, {UseHoverMenus} from "../layout/useHoverMenus";
import {FCWithChildren} from "@/app/types/reactTypes";

const TopNavHoverContext = createContext<UseHoverMenus | null>(null);

export const TopNavHoverProvider: FCWithChildren = ({children}) => {
	const hoverHandlers = useHoverMenus();

	return (
		<TopNavHoverContext.Provider value={hoverHandlers}>
			{children}
		</TopNavHoverContext.Provider>
	);
};

export const useTopNavHoverContext = () => {
	return useContext(TopNavHoverContext);
};
